import styled from "styled-components";
import {
  Button,
  Heading,
  normalStyles,
  shade800,
  shade900,
  smallStyles,
} from "@songtradr-one/components-frontend";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.entryList;

// STYLES
export const EntryListTitle = styled(Heading).attrs({ variant: "h3-strong" })`
  margin: 0;
`;

export const EntryListSubtitle = styled(Heading).attrs({ variant: "h4" })`
  margin: 0;
  opacity: 0.8;
`;

export const EntryListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 0.0625rem solid ${shade800};
  padding: 0.5rem;
`;

export const EntryListHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const EntryListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  min-height: 1.5rem;
  margin-top: -2.5rem;
  margin-bottom: 0.5rem;
  margin-right: -0.5rem;
`;

export const EntryListContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const EntryItem = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  gap: 1rem;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  transition: background-color 0.2s ease;

  &:hover {
    background: ${shade800};
  }
`;

export const EmptyStateContainer = styled.div`
  ${smallStyles};
  text-align: center;
  padding: 0.5rem;
`;

export const EntryLabel = styled.span`
  ${normalStyles};
  flex: 1;
  span {
    ${smallStyles};
    margin-left: 1rem;
    background: ${shade900};
    padding: 0.25rem 0.45rem;
  }
`;

export const EntryActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const AddEntryButton = styled(Button)`
  ${smallStyles};
  height: auto;
  padding: 0;
  background: transparent;

  &:hover:not(:disabled) {
    background: transparent;
  }
`;

// DATA

// TYPES
export interface EntryListHookResult<T> {
  entries: T[];
  isLoading: boolean;
  handleAddEntry: () => Promise<void>;
  handleEditEntry: (index: number, entry: T) => Promise<void>;
  handleRemoveEntry: (index: number, entry: T) => Promise<void>;
}
export type Entry = {
  label: string;
  value: string;
};
export type EntryAction<T = Entry> = {
  icon: React.ReactNode;
  onClick: (entry: T) => void;
  title?: string;
};

export type EntryAddAction<T = Entry> = {
  key: string;
  content: React.ReactNode;
  onAdd: () => Promise<T[] | void> | T[] | void;
};

export type EntryListProps<T = Entry> = {
  title?: string;
  subtitle?: string;
  initialEntries?: T[];
  onAddEntries?: () => Promise<T[] | void> | T[] | void;
  onReplaceEntries?: () => Promise<T[] | void> | T[] | void;
  addActions?: EntryAddAction<T>[];
  onEditEntry?: (entry: T, index: number) => Promise<T | void> | T | void;
  onEntriesChange?: (entries: T[]) => void;
  addButtonContent?: React.ReactNode;
  removeConfirmation?: (entry: T) => Promise<boolean> | boolean;
  disabled?: boolean;
  labelProperty?: keyof T;
  emptyText?: string;
  displayValue?: (entry: T) => string;
  actions?: EntryAction<T>[];
};

// CONSTANTS

// FUNCTIONS

// ASSETS
